import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-26" data-mp="bwxb8p3n24jm">
      <div className="max-w-5xl mx-auto" data-id="element-27" data-mp="by8gktcqfkcu">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#5A3FA0]" data-id="element-28" data-mp="pobxd4sueluw">
          ANTES VS DESPUÉS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-29" data-mp="kw0xu320l22v">
          {/* Antes */}
          <div className="bg-white rounded-2xl p-5 shadow-lg border-t-8 border-red-500" data-id="element-30" data-mp="zl6w9ot12o9p">
            <h3 className="text-2xl font-bold mb-3 text-red-600 text-center border-b pb-3" data-id="element-31" data-mp="unetfzquhhqq">
              Antes de Megapack ESI Secundaria
            </h3>
            <ul className="space-y-2 text-lg text-gray-700" data-id="element-32" data-mp="18kk64il2deuy">
              <li className="flex items-start" data-id="element-33" data-mp="13omrcgpg8gka">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-34" data-mp="13lqt0r9ovpvb" />
                <span data-id="element-35" data-mp="3ae9op8lrbay9">Improvisar actividades.</span>
              </li>
              <li className="flex items-start" data-id="element-36" data-mp="35fzq0o0tps7w">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-37" data-mp="35hatemqcwxyh" />
                <span data-id="element-38" data-mp="36mf6q4pd0h2r">Buscar material en distintos sitios.</span>
              </li>
              <li className="flex items-start" data-id="element-39" data-mp="3bo4hrkcl0uqu">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-40" data-mp="3gmzapf49jzoo" />
                <span data-id="element-41" data-mp="3gkv1qiricahj">Encontrar propuestas infantiles.</span>
              </li>
              <li className="flex items-start" data-id="element-42" data-mp="3leqw7b8kbf7y">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-43" data-mp="3pfj686p9do5a" />
                <span data-id="element-44" data-mp="3ududc9o65kjt">No saber cómo abordar temas sensibles.</span>
              </li>
              <li className="flex items-start" data-id="element-45" data-mp="3ufxe9oqv0y3b">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-46" data-mp="38un2xb0urt3" />
                <span data-id="element-47" data-mp="875vr4pkyw9q">Perder horas preparando clases.</span>
              </li>
            </ul>
          </div>

          {/* Después */}
          <div className="bg-white rounded-2xl p-5 shadow-lg border-t-8 border-green-500 transform md:scale-105" data-id="element-48" data-mp="250qx22hjjtlr">
            <h3 className="text-2xl font-bold mb-3 text-green-600 text-center border-b pb-3" data-id="element-49" data-mp="2a0d9i9pjp5ti">
              Después de Megapack ESI Secundaria
            </h3>
            <ul className="space-y-2 text-lg text-gray-900 font-medium" data-id="element-50" data-mp="1wzjiz2y18zl4">
              <li className="flex items-start" data-id="element-51" data-mp="2bvh9a4l9z9pf">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-52" data-mp="2bxbuzl4df5uk" />
                <span data-id="element-53" data-mp="26vuvnu1jbrg3">25 temas organizados en un solo material.</span>
              </li>
              <li className="flex items-start" data-id="element-54" data-mp="2kvdw00o3tyhu">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-55" data-mp="2ku2rtzqqyoq7" />
                <span data-id="element-56" data-mp="2fv9nawtfu826">Actividades listas para imprimir.</span>
              </li>
              <li className="flex items-start" data-id="element-57" data-mp="2ulpcemoz605m">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-58" data-mp="2pnfgg9vfeviy" />
                <span data-id="element-59" data-mp="33mwy85ab18it">Propuestas diseñadas para adolescentes.</span>
              </li>
              <li className="flex items-start" data-id="element-60" data-mp="33kkg9s4jqy5r">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-61" data-mp="2zmd0p0ltk2w5" />
                <span data-id="element-62" data-mp="3i9drgy2xvemz">Más análisis y pensamiento crítico.</span>
              </li>
              <li className="flex items-start" data-id="element-63" data-mp="3n8gl7mdgxyfn">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-64" data-mp="3n86w0108zvb0" />
                <span data-id="element-65" data-mp="3985vwnrt4rwl">Más seguridad para trabajar ESI.</span>
              </li>
              <li className="flex items-start" data-id="element-66" data-mp="3e78ze3s52q2g">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-67" data-mp="3ea4xpt7wfgrf" />
                <span data-id="element-68" data-mp="2zhtbcvjzsyqg">Menos tiempo buscando recursos.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}